import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface BankCountryInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function BankCountryInput({ value, onChange, disabled }: BankCountryInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.bankCountryInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
